import { render, staticRenderFns } from "./AcademyCreate.vue?vue&type=template&id=6f9f7494&"
import script from "./AcademyCreate.vue?vue&type=script&lang=js&"
export * from "./AcademyCreate.vue?vue&type=script&lang=js&"
import style0 from "./AcademyCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports